// extracted by mini-css-extract-plugin
module.exports = {"container":"Consumption_container__3-lHr"};